:host {
  display: block;
}

#google-map-container {
  height: 350px;
}
